import styled from 'styled-components';
import { compose, fontSize, variant } from 'styled-system';
import { COMMON, LAYOUT } from '../constants';
import buttonBaseStyles from './ButtonStyles';
export var buttonSystemProps = compose(fontSize, COMMON, LAYOUT);
var variants = variant({
  variants: {
    small: {
      p: '4px 12px',
      fontSize: 0
    },
    medium: {
      fontSize: 1
    },
    large: {
      fontSize: 2,
      p: '10px 20px'
    }
  }
});
var ButtonBase = styled.button.attrs(function (_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return {
    onClick: disabled ? undefined : onClick
  };
}).withConfig({
  displayName: "ButtonBase",
  componentId: "sc-181ps9o-0"
})(["", " ", ""], buttonBaseStyles, variants);
ButtonBase.defaultProps = {
  variant: 'medium'
};
export default ButtonBase;